.background {
    background-color: var(--off-white);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    overflow-y: auto;
}

.container {
    width: 564px;
    margin-top: 72px;
    padding: 0 32px;
}

.footer {
    margin-bottom: 36px;
}
